var Notifications = (function (_globalSettings, utils) {
    var obtainNotifications = function (userId) {
        var $ready = new $.Deferred();

        if (userId) {
            var url = 'api/shop/customer/v2/customer/accounts/' + _globalSettings.AccountId + '/notifications';
            utils.request.post(url, { userId: userId }).done(function (data) {
                $ready.resolve(data);
            });
        }

        return $ready.promise();
    };

    var displayNotification = function (code) {
        $('@notificationMessage').text('Code ' + code + ' has been copied to clipboard');
        $('@notification').removeClass('hidden-block');
        setTimeout(function () {
            $('@notification').addClass('hidden-block');
        }, 2000);
    };

    var renderNotifications = function(data) {
        $('@notificationsPanel').html($.tmpl('notifications-panel', { List: data })).removeClass('hidden-block');

        $('@notificationsPanel').slick({
            autoplay: true,
            autoplaySpeed: 6000,
            responsive: [{
                breakpoint: 550,
                settings: {
                    arrow: false
                }
            }]
        });

        $('@notificationsPanel').find('a').on('click', function (e) {
            var code = $(this).text();
            var el = document.createElement('textarea');
            el.value = code;
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            displayNotification(code);
        });
    }

    return {
        getNotifications: function (userId) {
            return obtainNotifications(userId).done(renderNotifications);
        }
    }

})(GlobalSettings, utils);